'use strict';

require('./email-styles.scss');

const React = require('react');

const EmailLinkElement = React.createClass({

  render: function() {
    const {_id, transformDate, subject} = this.props;

    return (
      <a className='issue-item-link'
         target='_blank'
         href={`/email/${_id}`} >
        <div className="issue-item text-bordered">
          <div className="issue-item-date">{transformDate}</div>
          <div className="issue-item-title">{subject}</div>
        </div>
      </a>
    );
  }
});

module.exports = EmailLinkElement;



// WEBPACK FOOTER //
// ./src/client/components/email/email-link-element.jsx